import Typography from "@sendsprint/ui-react/components/typography";
import React, { FC, ReactNode } from "react";

type ErrorCardProps = {
  imageContent: ReactNode;
  title: string;
  content: ReactNode;
  footer: ReactNode;
};

const ErrorCard: FC<ErrorCardProps> = ({
  imageContent,
  title,
  content,
  footer,
}) => {
  return (
    <div className="ss:rounded ss:overflow-hidden ss:shadow ss:bg-white ss:text-center">
      {imageContent}
      <div className="ss:py-10 ss:max-w-lg ss:mx-auto">
        <Typography
          as="h1"
          variant="h6"
          className="ss:text-neutral-600 ss:mb-4"
        >
          {title}
        </Typography>
        <Typography className="ss:text-neutral-400">{content}</Typography>
        <div className="ss:mt-8">{footer}</div>
      </div>
    </div>
  );
};

export type { ErrorCardProps };
export default ErrorCard;
